/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/List/theme';

export const ListTheme = theme;
